export enum ContactType {
  FAX,
  EMAIL,
  MAIL,
}

/** Describes the shape of the address fields needed for a college/school. */
export type CollegeAddress = {
  street: string;
  city: string;
  state: string;
  zip: string;
};

export type TranscriptRequest = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  recipientSchoolName: string;
  applicationDeadline: string;
  contactType: ContactType;
  collegeAddress: CollegeAddress;
  collegeFax: string;
  collegeEmail: string;
};
